module.exports = __webpack_public_path__ + "img/code-square-01.9b2afe49.svg";